<section
  *ngIf="content && content.isDelta"
  id="mach-core-account-summary-header"
  class="relative text-white w-auto h-[154px] tablet:h-[148px] laptop:h-[145px] gap-[15px] pt-16 px-16 tablet:pt-24 tablet:px-24 laptop:pt-32 laptop:px-32 pb-16"
  [style.background]="getHeaderGradient()"
>
  <div
    class="absolute top-[1rem] right-[1rem] hidden laptop:block"
    id="mach-core-account-summary-close"
  >
    <button class="w-[24px] h-[24px]" (click)="onClose()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-full h-full"
      >
        <path
          d="M21.001 4.16016L13.1494 12.001L20.9971 19.8398L19.835 21L11.9883 13.1621L4.16504 20.9766L3.00391 19.8164L10.8262 12.001L3 4.18359L4.16211 3.02344L11.9883 10.8408L19.8389 3L21.001 4.16016Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <div
    *ngIf="!content.is360Tier"
    id="mach-core-account-summary-logo"
    class="absolute top-0 left-0 w-[140px] h-18 tablet:w-[140px] tablet:h-18 laptop:w-[170px] laptop:h-[66px] opacity-100 flex items-start gap-2"
  >
    <div
      class="absolute top-0 left-0 w-[140px] h-[70px] tablet:w-[140px] tablet:h-[70px] laptop:w-[132px] laptop:h-[66px]"
    >
      <svg
        width="132"
        height="66"
        viewBox="0 0 132 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-full h-full"
      >
        <g clip-path="url(#clip0_21211_118961)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.8086 -0.154188L37.4253 19.6595L21.2983 19.6594L33.042 8.32574L51.8086 -0.154188Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4754 38.3348L2.1252 32.112L6.06915 25.1851L15.2656 23.5785L12.4754 38.3348Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.303 19.6608L26.1028 57.4219L51.8125 -0.152344L21.303 19.6608Z"
            fill="#991933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.12522 32.1116L22.2772 63.1429L15.2656 23.5781L2.12522 32.1116Z"
            fill="#991933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.0606 -0.24172L-10.9977 -0.177696L21.5503 19.5719L52.0606 -0.24172Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-18.0252 1.08426L2.12633 32.1148L15.2667 23.5814L-18.0252 1.08426Z"
            fill="#E01933"
          />
        </g>
        <defs>
          <clipPath id="clip0_21211_118961">
            <rect width="132" height="66" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>

    <!-- Million Miler Logo -->
    <div
      *ngIf="content.millionMiler"
      class="absolute top-[9px] left-[56px] w-[20px] h-[28px] tablet:top-[8px] tablet:left-[70px] tablet:w-[24px] tablet:h-[34px] laptop:top-[4px] laptop:left-[50px] laptop:w-[28px] laptop:h-[32px]"
    >
      <img
        [src]="getMillionMilerSvgUrl()"
        alt="Million Miler"
        class="w-full h-full brightness-0 invert"
      />
    </div>
  </div>
  <div
    *ngIf="content.is360Tier"
    id="mach-core-account-summary-360-logo"
    class="absolute top-[-7px] left-[13px] w-[120px] h-[60px] tablet:top-[-7px] tablet:left-[13px] tablet:w-[140px] tablet:h-[70px] laptop:top-[16px] laptop:left-0 laptop:w-[132px] laptop:h-[35px] opacity-100 flex items-end gap-2"
  >
    <div
      class="absolute bottom-0 left-[24px] w-[50px] h-[25px] tablet:left-[28px] tablet:w-[60px] tablet:h-[30px] laptop:left-[32px] laptop:w-[48px] laptop:h-[25px] opacity-100"
    >
      <svg
        width="48"
        height="26"
        viewBox="0 0 48 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-full h-full"
      >
        <path
          d="M35.6885 4.375C39.9796 4.375 42.6467 8.1905 42.6523 14.1982C42.6523 20.2339 39.9573 24.0771 35.6885 24.0771C31.3919 24.0771 28.7246 20.2616 28.7246 14.2539C28.7247 8.21838 31.4198 4.37506 35.6885 4.375ZM24.1064 6.05762C19.6424 7.29039 16.6118 9.73373 15.9365 14.001C17.4822 12.9355 19.1678 12.2891 21.0762 12.2891C24.5859 12.2891 26.8574 14.4753 26.8574 17.9561C26.8574 21.6041 24.1899 24.075 20.6523 24.0752C16.7798 24.0752 13.9727 21.0465 13.9727 16.0205C13.9727 9.59456 17.9287 6.00251 23.8545 4.3457L24.1064 6.05762ZM5.72559 4.37305C9.56999 4.3732 11.3945 6.58826 11.3945 9.1709C11.3943 11.6418 9.77029 13.0141 7.77832 13.6611C10.2223 14.364 11.7625 15.9032 11.7627 18.5693C11.7627 21.7991 9.12343 24.0703 5.30664 24.0703C3.25876 24.0703 1.35038 23.4503 0 22.5801L0.306641 20.7285C1.93595 21.8497 3.39255 22.3857 5.41797 22.3857C8.11316 22.3857 9.82617 20.8959 9.82617 18.5977C9.82616 16.1265 8.14099 14.5586 4.32422 14.5586H3.48242L3.23047 12.874H4.51953C7.77831 12.874 9.45801 11.4685 9.45801 9.25391C9.45791 7.40206 8.16921 6.0518 5.6416 6.05176C3.64951 6.05176 1.9917 6.78264 0.557617 7.87598L0.306641 6.1084C1.76863 5.07642 3.45449 4.37305 5.72559 4.37305ZM20.7637 13.9121C18.9112 13.9121 17.2815 14.6703 15.8252 15.8193V15.9316C15.8253 19.7748 17.7894 22.4413 20.6797 22.4414C23.2632 22.447 24.9482 20.7063 24.9482 18.04C24.9482 15.5968 23.5704 13.9122 20.7637 13.9121ZM35.6885 6.03223C32.4298 6.03229 30.6328 9.26197 30.6328 14.2266C30.6329 19.191 32.4298 22.4208 35.6885 22.4209C38.9416 22.4209 40.7441 19.191 40.7441 14.2266C40.7441 9.26192 38.9473 6.03223 35.6885 6.03223ZM44.5791 0C45.9462 0 47.0625 1.11017 47.0625 2.48242C47.0623 3.85453 45.9517 4.96484 44.5791 4.96484C43.2066 4.96469 42.0968 3.85443 42.0967 2.48242C42.0967 1.11027 43.2065 0.00015782 44.5791 0ZM44.5791 0.892578C43.6976 0.892736 42.9893 1.60673 42.9893 2.48242C42.9894 3.35797 43.7033 4.07211 44.5791 4.07227C45.4551 4.07227 46.1698 3.35807 46.1699 2.48242C46.1699 1.60664 45.4608 0.892578 44.5791 0.892578Z"
          fill="white"
        />
        <path
          d="M36.8623 14.8506L32.8613 17.4336L30.6348 14.0303C30.6459 12.8757 30.7572 11.8215 30.958 10.8789L36.8623 14.8506ZM38.707 13.6621L31.4414 9.27148C31.6925 8.65238 31.9994 8.11097 32.3564 7.65918L47.9971 7.64844L38.707 13.6621Z"
          fill="#991933"
        />
        <path
          d="M40.1787 25.1084L38.7051 13.6504L48.002 7.64844L40.1787 25.1084ZM38.084 21.6826C37.5094 22.0842 36.8511 22.3295 36.1035 22.3965L32.8555 17.4268L36.8564 14.8438L38.084 21.6826Z"
          fill="#E01933"
        />
      </svg>
    </div>

    <div
      *ngIf="content.millionMiler"
      class="absolute bottom-0 left-[80px] w-[26px] h-[36px] tablet:left-[95px] tablet:w-[30px] tablet:h-[42px] laptop:left-[88px] laptop:w-[28px] laptop:h-[32px]"
    >
      <img
        [src]="getMillionMilerSvgUrl()"
        alt="Million Miler"
        class="w-full h-full brightness-0 invert"
      />
    </div>
  </div>

  <div
    id="mach-core-account-summary-info"
    class="absolute top-[70px] left-[38px] w-[280px] min-h-[60px] tablet:top-[74px] tablet:left-[38px] tablet:w-[300px] tablet:min-h-[70px] laptop:left-[9%] laptop:top-[60px] laptop:w-[266px] laptop:min-h-[80px] flex flex-col gap-[8px] tablet:gap-[10px] laptop:gap-[12px]"
  >
    <div
      id="mach-core-account-summary-greeting"
      class="text-[28px] leading-[32px] tablet:text-[32px] tablet:leading-[36px] laptop:text-[33px] laptop:leading-[37px] font-semibold tracking-[-0.5px] text-[#FFFFFF] overflow-hidden"
    >
      {{ content.greetingMessage }}
      <span class="sr-only">{{ content.greetingMessage }}</span>
    </div>

    <div
      class="w-full h-[18px] tablet:h-[19px] laptop:h-[20px] flex items-center gap-[8px] tablet:gap-[10px] laptop:gap-[12px]"
    >
      <span
        id="mach-core-account-summary-skymiles-number"
        class="text-[13px] font-normal leading-[20px] text-[#FFFFFF]"
      >
        {{ content.skyMilesNumber }}
      </span>
      <span
        id="mach-core-account-summary-divider"
        class="text-[13px] font-medium leading-[20px] text-[#FFFFFF] opacity-20"
      >
        |
      </span>
      <span
        id="mach-core-account-summary-miles-available"
        class="text-[13px] font-normal leading-[20px] text-[#FFFFFF]"
      >
        {{ content.skymilesBalance | number }}
        {{ content.labels.availableMilesLabel }}
      </span>
      <span class="sr-only">
        #{{ content.skyMilesNumber }}
        {{ content.skymilesBalance | number }}
        {{ content.labels.availableMilesLabel }}
      </span>
    </div>
  </div>
</section>

<div
  *ngIf="content && content.isDelta"
  id="mach-core-account-summary-status"
  class="w-auto h-[40px] tablet:h-[44px] laptop:h-[48px] py-8 pl-[38px] pr-16 tablet:py-10 tablet:pl-[38px] tablet:pr-24 laptop:py-12 laptop:px-32 text-white flex items-center justify-between"
  [style.background]="getBottomContainerBg()"
>
  <div class="flex gap-[8px] items-center">
    <span
      id="mach-core-account-summary-current-status-label"
      class="text-[14px] font-light leading-[20px] text-[#FFFFFF] whitespace-nowrap"
    >
      {{ content.labels.currentStatusLabel }}
    </span>
    <span
      id="mach-core-account-summary-status-value"
      class="text-[14px] font-semibold leading-[20px] text-[#FFFFFF] whitespace-nowrap"
    >
      {{ content.memberDescriptionMessage }}
    </span>
    <span class="sr-only">
      {{ content.labels.currentStatusLabel }}
      {{ content.memberDescriptionMessage }}
    </span>
  </div>
  <span
    *ngIf="content.skyPriority"
    class="w-auto h-[24px] px-8 py-[9px] bg-[#EB0000] rounded-[15px] text-[12px] font-semibold text-[#FFFFFF] flex items-center justify-center ml-8 whitespace-nowrap flex-shrink-0"
    aria-label="Sky Priority"
  >
    SKY PRIORITY
  </span>
</div>
